import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePlacesAvailabilityState = () => React.useContext(Context) || {}
export const usePlacesAvailability = () => usePlacesAvailabilityState()?.places || []

// `places` returns every place in the workspace, not only the ones with an active
// lock — a place with no lock simply comes back as "available". Never add a
// default `availabilityStatus` filter here, it would defeat that behaviour.
const QUERY = gql`
  query Places($page: Int, $search: String, $sort: PlaceSort, $filter: PlaceFilter) {
    places(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      resume
      placeLevelsResume
      type
      availabilityStatus
      availabilityStatusOrigin
      availabilityStatusChangedAt
      locks {
        id
        reason
        origin
        insertedAt
        createdBy {
          id
          name
        }
      }
    }
  }
`

const PlacesAvailabilityLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type: type || 'ASC' },
      filter
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default PlacesAvailabilityLoader
